import React, { FC, HTMLAttributes } from "react";
import { styled } from "@mui/system";
import { COLORS, SHADOWS, SPACINGS, RADII } from "../../common/consts";
import { HUBSPOT_TILE } from "../HubSpotUi/theme";

const StyledContainer = styled("div")`
  overflow-y: auto;
  background-color: var(--color-backgroundWhite, var(--color-backgroundPrimary, ${COLORS.backgroundPrimary}));
  box-shadow: ${SHADOWS.small};
  border-radius: ${RADII.md};
  padding: ${SPACINGS.lg};
  padding-top: ${SPACINGS.xl};
  transition: background-color 0.3s ease;
  color: var(--color-foregroundPrimary, ${COLORS.foregroundPrimary});
  ${HUBSPOT_TILE}
`;

const Card: FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <StyledContainer className={className} {...rest}>
      {children}
    </StyledContainer>
  );
};

export default Card;
